<template>
  <div class="infoMessageBox" v-show="isShowMessageBox">
    <div class="mask"></div>
    <div class="box" :style="{width}">
      <i class="closeIcon el-icon-close" @click="cancel()"></i>
      <h3 class="title">{{title}}</h3>
      <div class="content"  v-html="content"></div>
    </div>
  </div>
</template>
  

<script>
export default {
  props: {
    width: {
      type: String,
      default: "600px"
    },
    title: {
      type: String,
      default: "提示"
    },
    content: {
      type: String,
      default: ""
    },
  },
  created(){
    
  },
  data() {
    return {
        isShowMessageBox: false,
        resolve: '',
        reject: '',
        promise: '', // 保存promise对象
    };
  },
  methods: {
    // 确定,将promise断定为resolve状态
    confirm: function (row) {
      this.isShowMessageBox = false;
      if(row){
        this.resolve(row);
      }else{
        this.resolve(this.activeArr);
      }
      this.remove();
    },
    // 取消,将promise断定为reject状态
    cancel: function () {
      this.isShowMessageBox = false;
      this.reject('cancel');
      this.remove();
    },
    // 弹出messageBox,并创建promise对象
    infoMessageBox: function () {
      this.isShowMessageBox = true;
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      return this.promise;
    },
    remove: function () {
      setTimeout(() => {
        this.destroy();
      }, 300);
    },
    destroy: function () {
      this.$destroy();
      document.body.removeChild(this.$el);
    }
  }
};
</script>
<style lang="scss">
.infoMessageBox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  margin: auto;
  z-index: 999;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    margin: auto;
    background: rgba($color: #000000, $alpha: 0.25);
  }
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding:32px 50px 42px  50px;
    border-radius: 5px;
    background: #fff;
    color: #777;
    .closeIcon {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 18px;
      z-index: 9;
      cursor: pointer;
    }
    .title {
      margin-bottom: 20px;
      min-height: 30px;
      padding-bottom: 15px;
      font-size: 20px;
      border-bottom: 1px solid #CCCCCC;
      font-weight: bold;
      text-align: center;
    }
    .content {
      font-size: 16px;
      line-height: 24px;
      //误删：有用
      table{width:100%; border-collapse:collapse;}
      th,td{ border:1px solid black;padding:10px;}
    }
  }
}
</style>